module.exports = __webpack_public_path__ + "static/media/01.5d8145cc.png";